<template>
  <b-container>
    <h2>{{ $t('projets_par_categorie') }}</h2>
    <div class="mb-3">
      <router-link to="/projets">← {{ $t('retour_projets') }}</router-link>
    </div>

    <div v-if="loading" class="d-flex justify-content-center align-items-center my-5">
      <b-spinner/>
    </div>

    <div v-else>
      <div v-if="categoryKeys.length === 0" class="text-muted">
        {{ $t('aucun_projet') }}
      </div>

      <div v-for="cat in categoryKeys" :key="cat" class="mb-4">
        <h4>
          <b-badge variant="info" class="mr-2">{{ cat }}</b-badge>
          <small class="text-muted">{{ projectsByCategory[cat].length }}</small>
        </h4>
        <ul class="mb-3">
          <li v-for="p in projectsByCategory[cat]" :key="p.path">
            <router-link :to="p.path.replace('projets/', '')">{{ p.titre }}<!-- -{{p.path}}--></router-link>
            <span class="year ml-2" v-if="p.annee">{{ p.annee }}</span>
            <div class="text-muted" v-if="p.description">{{ p.description }}</div>
            <div>
              <b-badge v-for="c in getCategories(p)" :key="p.path + '_' + c" variant="light" class="mr-1 category-tag">{{ c }}</b-badge>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </b-container>
</template>

<script>
import {getProjets} from '@/api';

export default {
  name: 'ProjectsByCategory',
  data() {
    return {
      loading: true,
      projets: [],
      projectsByCategory: {}
    }
  },
  computed: {
    categoryKeys() {
      return Object.keys(this.projectsByCategory).sort((a,b)=>a.localeCompare(b));
    }
  },
  methods: {
    getCategories(p) {
      // Backend may provide either `categories` or `categorie` (array or string)
      let cats = p.categories || p.categorie || [];
      if (typeof cats === 'string') {
        cats = [cats];
      }
      return cats;
    },
    groupByCategory() {
      const map = {};
      this.projets.forEach(p => {
        const cats = this.getCategories(p);
        if (!cats || cats.length === 0) {
          const noCat = this.$t('sans_categorie');
          if (!map[noCat]) map[noCat] = [];
          map[noCat].push(p);
        } else {
          cats.forEach(c => {
            if (!map[c]) map[c] = [];
            map[c].push(p);
          });
        }
      });
      this.projectsByCategory = map;
    },
    load() {
      this.loading = true;
      getProjets(this.$i18n.locale).then(res => {
        this.projets = res.data.projets || [];
        this.groupByCategory();
      }).finally(()=>{
        this.loading = false;
      });
    }
  },
  mounted() {
    this.load();
  }
}
</script>

<style scoped>
.category-tag {
  font-size: 0.8em;
}
.year {
  font-size: 0.9em;
}
</style>
